import { PagedListResponse, SuccessResponse, User, X5LessonSnapshot } from 'domain/index';
import { HttpPromiseState } from 'lib/helpers';
import { environment } from 'lib/environment';
import { httpClient } from 'domain/utils/httpClient';
import {
    EssayViewModel,
    EssayStudentSubmitViewModel,
    EssayTeacherSubmitViewModel,
    EssayTeacherListResponse,
    EssayStudentSaveViewModel,
    ExamStudentListResponse,
    EssayListDto
} from './ExamModels';
import { AxiosRequestConfig } from 'axios';

class ExamLoadersClass {
    getEssay(essayId: number): HttpPromiseState<EssayViewModel> {
        let url = `${environment.apiServer}/essay/open`;
        const cfg: AxiosRequestConfig = {
            params: { essayId }
        };
        return httpClient.state.get<EssayViewModel>(url, cfg);
    }

    studentSubmit(essayId: number, text: string) {
        const url = `${environment.apiServer}/essay/student/submit`;
        const data = new EssayStudentSubmitViewModel(essayId, text);
        return httpClient.axios.postWithSweetAlert(url, data);
    }

    studentSave(essayId: number, text: string) {
        const url = `${environment.apiServer}/essay/student/save`;
        const data = new EssayStudentSaveViewModel(essayId, text);
        return httpClient.axios.postWithSweetAlert(url, data);
    }

    teacherSubmit(essayId: number, text: string, accept: boolean, rating: number | null, comment: string | null) {
        const url = `${environment.apiServer}/essay/teacher/submit`;
        const data = new EssayTeacherSubmitViewModel(essayId, text, accept, rating, comment);
        return httpClient.axios.postWithSweetAlert(url, data);
    }

    teacherGetList(request: EssayListDto) {
        const url = `${environment.apiServer}/exam/teacher/list`;
        return httpClient.state.post<ExamStudentListResponse>(url, request);
    }

    studentGetList(request: EssayListDto) {
        const url = `${environment.apiServer}/exam/student/list`;
        return httpClient.state.post<ExamStudentListResponse>(url, request);
    }
}

export const ExamLoaders = new ExamLoadersClass();
